var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareArrowLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up-right-arrow 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.29167 18.75C6.97917 18.75 6.77083 18.6458 6.5625 18.4375C6.14583 18.0208 6.14583 17.3958 6.5625 16.9792L16.9792 6.5625C17.3958 6.14583 18.0208 6.14583 18.4375 6.5625C18.8542 6.97917 18.8542 7.60417 18.4375 8.02083L8.02083 18.4375C7.8125 18.6458 7.60417 18.75 7.29167 18.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7096 17.7083C17.0846 17.7083 16.668 17.2917 16.668 16.6667V8.33333H8.33464C7.70964 8.33333 7.29297 7.91667 7.29297 7.29167C7.29297 6.66667 7.70964 6.25 8.33464 6.25H17.7096C18.3346 6.25 18.7513 6.66667 18.7513 7.29167V16.6667C18.7513 17.2917 18.3346 17.7083 17.7096 17.7083Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrowLight);
export default __webpack_public_path__ + "static/media/shareArrowLight.f6dc5109557f44f9a2885335d6cfbc38.svg";
export { ForwardRef as ReactComponent };